var $ = global.jQuery = global.$;

var _Base = require('./_Base');
/**
 * Widget for toggling the filter menu
 * @class
 * @extends _Base
 */
var FilterToggle = _Base.extend(
  /** @lends FilterToggle.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$toggle = this.$el.find('[data-toggle]');
    this.$icon = this.$toggle.find('.icon');
    this.$dropdown = this.$el.find('[data-filters]');

    this.classes = {
      open: 'is-open',
      openIcon: 'icon--plus',
      closeIcon: 'icon--minus'
    };

    this.isOpen = this.$el.hasClass(this.classes.open);

    if (self.isOpen) {
      self.open();
    } else {
      self.close();
    }

    this.$toggle.on('click', this._toggleClickHandler.bind(this));
  },
  /**
   * Handle toggle clicks. Close menu if open or open menu if closed
   * @private
   */
  _toggleClickHandler: function(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  },
  /**
   * Close menu
   */
  close: function() {
    this.$dropdown.velocity('slideUp');
    this.$icon.removeClass(this.classes.closeIcon);
    this.$icon.addClass(this.classes.openIcon);
    this.$el.removeClass(this.classes.open);
    this.isOpen = false;
  },
  /**
   * Open menu
   */
  open: function() {
    this.$dropdown.velocity('slideDown');
    this.$icon.removeClass(this.classes.openIcon);
    this.$icon.addClass(this.classes.closeIcon);
    this.$el.addClass(this.classes.open);
    this.isOpen = true;
  }
});

module.exports = FilterToggle;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/FilterToggle.js
 ** module id = 235
 ** module chunks = 0 1
 **/